export const mapTaskFromApi = (task) => ({
    id: task.id,
    title: task.title,
    description: task.description,

    technician: task.technician
        ? {
              name: task.technician.name,
              phone: task.technician.phone,
              email: task.technician.email,
          }
        : { name: "Unassigned" },

    customer: {
        name: task.customer.name,
        phone: task.customer.phone,
        location: task.customer.location,
    },

    tractor: {
        model: task.tractor.model,
        serial: task.tractor.serial,
        engineHours: task.tractor.engineHours,
        year: task.tractor.year,
    },

    assignedDate: task.assignedDate,
    dueDate: task.dueDate,
    estimatedHours: task.estimatedHours,
    actualHours: task.actualHours,
    status: task.status.replaceAll("_", " "),

    checklist: task.checklist || [],
    location: task.location,
    comments: task.comments || [],
    attachments: task.attachments || [],
});
